import React from "react";
import { useSelector } from "react-redux";
import TransactionCard from "./TransactionCard";

const TransactionCards = (props) => {
  let { state: profileState } = useSelector((state) => ({
    state: state.profile,
  }));

  return (
    <div className="row flex-column  rounded  mx-auto mt-3 text-right container p-0">
      <TransactionCard data={profileState.transactions} />
    </div>
  );
};

export default TransactionCards;
